import React, { useEffect, useRef, useState } from 'react';
import ApexCharts from 'apexcharts';
import { apiClient } from '../../services/apiClient';

const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

const AdminDashbaord = () => {

    const hasFetched = useRef(false);

    const [dashboardData, setDashboardData] = useState({
        totalBusinesses: 0,
        activeBusinesses: 0,
        subscribers: 0,
        totalEarnings: 0,
        recentBusinesses: [],
        expiringBusinesses: [],
        transactions: [],
    });

    const [localUserData] = useState({
        name: capitalizeFirstLetter(localStorage.getItem("name") || "Guest"),
    });

    const fetchDashboardData = async () => {
        try {
            const response = await apiClient.get('/owner-dashboard');
            if (response.success && response.data) {
                setDashboardData({
                    totalBusinesses: response.data.total_businesses || 0,
                    activeBusinesses: response.data.active_businesses || 0,
                    subscribers: response.data.subscriber_count || 0,
                    totalEarnings: response.data.total_transaction_sum || 0,
                    recentBusinesses: response.data.recent_businesses || [],
                    expiringBusinesses: response.data.expiring_soon_businesses || [],
                    transactions: response.data.recent_transactions || [],
                });
            }
        } catch (error) {
            console.error("Dashboard fetch error:", error.message);
        }
    };

    useEffect(() => {
        if (!hasFetched.current) {
            fetchDashboardData();
            hasFetched.current = true;
        }
        let charts = [];

        // Initialize company chart
        if (document.getElementById('company-chart')) {
            const options = {
                chart: {
                    height: 350,
                    type: 'line',
                    toolbar: {
                        show: false
                    }
                },
                series: [{
                    name: 'Companies',
                    data: [45, 60, 75, 51, 42, 42, 30]
                }],
                colors: ['#28C76F'],
                xaxis: {
                    categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
                }
            };

            const chart = new ApexCharts(document.getElementById('company-chart'), options);
            chart.render();
            charts.push(chart);
        }

        // Initialize small sparkline charts
        const initializeSparkline = (selector, data, colors) => {
            const element = document.querySelector(selector);
            if (element) {
                const options = {
                    chart: {
                        type: 'line',
                        height: 30,
                        width: 100,
                        sparkline: {
                            enabled: true
                        },
                        toolbar: {
                            show: false
                        }
                    },
                    stroke: {
                        width: 2,
                        curve: 'smooth'
                    },
                    colors: [colors],
                    tooltip: {
                        fixed: {
                            enabled: false
                        },
                        x: {
                            show: false
                        },
                        marker: {
                            show: false
                        }
                    },
                    series: [{
                        data: data
                    }]
                };

                const chart = new ApexCharts(element, options);
                chart.render();
                charts.push(chart);
            }
        };

        // Initialize all sparkline charts
        initializeSparkline('.company-bar1', [5, 10, 7, 12, 3, 10], '#28C76F');
        initializeSparkline('.company-bar2', [10, 5, 7, 10, 3, 10, 5], '#FF5B5C');
        initializeSparkline('.company-bar3', [3, 10, 5, 10, 7, 10], '#FDAC41');
        initializeSparkline('.company-bar4', [5, 10, 7, 5, 10, 7, 5], '#00CFE8');

        // Cleanup function
        return () => {
            charts.forEach(chart => {
                if (chart) {
                    chart.destroy();
                }
            });
        };
    }, []);


    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    <div className="d-lg-flex align-items-center justify-content-between mb-4">
                        {/* <div>
                            <h2 className="mb-1">Welcome, {capitalizeFirstLetter(localUserData.name)}</h2>
                            <p>You have <span className="text-primary fw-bold">200+</span> Orders, Today</p>
                        </div> */}
                        {/* <ul className="table-top-head">
                            <li>
                                <div className="input-icon-start">
                                    <input type="text" className="form-control date-range bookingrange" placeholder="Search Product" />
                                </div>
                            </li>
                        </ul> */}
                    </div>

                    <div className="welcome-wrap mb-4">
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <div className="mb-3">
                                <h2 className="mb-1 text-white">Welcome Back, {capitalizeFirstLetter(localUserData.name)}</h2>
                                {/* <p className="text-light">14 New Companies Subscribed Today !!!</p> */}
                            </div>
                            {/* <div className="d-flex align-items-center flex-wrap mb-1">
                                <a className="btn btn-dark btn-md me-2 mb-2">
                                    Companies
                                </a>
                                <a className="btn btn-light btn-md mb-2">
                                    All Packages
                                </a>
                            </div> */}
                        </div>

                        <div className="welcome-bg">
                            <img
                                src="../../assets/img/product/welcome-bg-02.svg"
                                alt="background image"
                                className="welcome-bg-01"
                            />
                            <img
                                src="../../assets/img/product/welcome-bg-01.svg"
                                alt="background image"
                                className="welcome-bg-03"
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xl-3 col-sm-6 d-flex">
                            <div className="card flex-fill">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <span className="avatar avatar-md bg-dark mb-3">
                                            <i className="ti ti-building fs-16"></i>
                                        </span>
                                        {/* <span className="badge bg-success fw-normal mb-3">
                                            +19.01%
                                        </span> */}
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div>
                                            <h2 className="mb-1">{dashboardData.totalBusinesses}</h2>
                                            <p className="fs-13">Total Businesses</p>
                                        </div>
                                        <div className="company-bar1"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-3 col-sm-6 d-flex">
                            <div className="card flex-fill">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <span className="avatar avatar-md bg-dark mb-3">
                                            <i className="ti ti-carousel-vertical fs-16"></i>
                                        </span>
                                        {/* <span className="badge bg-danger fw-normal mb-3">
                                            -12%
                                        </span> */}
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div>
                                            <h2 className="mb-1">{dashboardData.activeBusinesses}</h2>
                                            <p className="fs-13">Active Businesses</p>
                                        </div>
                                        <div className="company-bar2"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-3 col-sm-6 d-flex">
                            <div className="card flex-fill">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <span className="avatar avatar-md bg-dark mb-3">
                                            <i className="ti ti-chalkboard-off fs-16"></i>
                                        </span>
                                        {/* <span className="badge bg-success fw-normal mb-3">
                                            +6%
                                        </span> */}
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div>
                                            <h2 className="mb-1">{dashboardData.subscribers}</h2>
                                            <p className="fs-13">Total Subscribers</p>
                                        </div>
                                        <div className="company-bar3"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-3 col-sm-6 d-flex">
                            <div className="card flex-fill">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <span className="avatar avatar-md bg-dark mb-3">
                                            <i className="ti ti-businessplan fs-16"></i>
                                        </span>
                                        {/* <span className="badge bg-danger fw-normal mb-3">
                                            -16%
                                        </span> */}
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div>
                                            <h2 className="mb-1">{dashboardData.totalEarnings}</h2>
                                            <p className="fs-13">Total Earnings</p>
                                        </div>
                                        <div className="company-bar4"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">

                        <div className="col-xxl-6 col-xl-6 d-flex">
                            <div className="card flex-fill">
                                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                                    <h5 className="mb-2">Recently Registered</h5>
                                    {/* <a href="purchase-transaction.html" className="btn btn-light btn-sm mb-2">View All</a> */}
                                </div>
                                <div className="card-body pb-2">
                                    {dashboardData.recentBusinesses.map((biz) => (
                                        <div key={biz.id} className="d-sm-flex justify-content-between flex-wrap mb-3">
                                            <div className="d-flex align-items-center mb-2">
                                                {/* <span className="avatar bg-gray-100 rounded-circle flex-shrink-0">
                                                    <i className="ti ti-building"></i>
                                                </span> */}
                                                <div className="ms-2 flex-fill">
                                                    <h6 className="fs-medium text-truncate mb-1">{biz.name}</h6>
                                                    <p className="fs-13">{biz.email}</p>
                                                </div>
                                            </div>
                                            <div className="text-sm-end mb-2">
                                                {/* <h6>{biz.subscription_expiry ? `Expiry: ${biz.subscription_expiry}` : 'No Plan'}</h6> */}
                                                <h6>
                                                    {biz.subscription_expiry ? `Expiry: ${biz.subscription_expiry.split('-').reverse().join('-')}`: 'No Plan'}
                                                </h6>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="col-xxl-6 col-xl-6 d-flex">
                            <div className="card flex-fill">
                                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                                    <h5 className="mb-2">Recent Plan Expired</h5>
                                    {/* <a href="purchase-transaction.html" className="btn btn-light btn-sm mb-2">View All</a> */}
                                </div>
                                <div className="card-body pb-2">
                                    {dashboardData.expiringBusinesses.map((biz) => (
                                        <div key={biz.id} className="d-sm-flex align-items-center justify-content-between flex-wrap mb-3">
                                            <div className="d-flex align-items-center mb-2">
                                                <span className="avatar bg-gray-100 rounded-circle flex-shrink-0">
                                                    <i className="ti ti-businessplan"></i>
                                                </span>
                                                <div className="ms-2 flex-fill">
                                                    <h6 className="fs-medium text-truncate mb-1">{biz.name}</h6>
                                                    <p className="fs-13">Expiry: {biz.subscription_expiry}</p>
                                                </div>
                                            </div>
                                            <div className="text-sm-end mb-2">
                                                <a href="#" className="link-info text-decoration-underline">Send Reminder</a>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 d-flex">
                            <div className="card flex-fill">
                                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                                    <h5 className="mb-2">Recent Transactions</h5>
                                    {/* <a href="purchase-transaction.html" className="btn btn-light btn-sm mb-2">View All</a> */}
                                </div>
                                <div className="card-body pb-2">
                                    {dashboardData.transactions.map((tx) => (
                                        <div key={tx.id} className="d-sm-flex justify-content-between flex-wrap mb-3">
                                            <div className="d-flex align-items-center mb-2">
                                                {/* <span className="avatar bg-gray-100 rounded-circle flex-shrink-0">
                                                    <i className="ti ti-credit-card"></i>
                                                </span> */}
                                                <div className="ms-2 flex-fill">
                                                    <h6 className="fs-medium text-truncate mb-1">{tx.business_name}</h6>
                                                    <p className="fs-13">{new Date(tx.created_at).toLocaleDateString()}</p>
                                                </div>
                                            </div>
                                            <div className="text-sm-end mb-2">
                                                <h6 className="mb-1">+{tx.amount}</h6>
                                                <p className="fs-13">Expiry: {tx.expiry_date}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AdminDashbaord;
